import { ControlLabel, DropdownItem, DropdownText, Radio } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ActionButtons from 'components/Filters/ActionButtons'

const RadioGroup = ({
  label = '',
  name,
  value,
  options,
  onDrop = () => {},
  onApply = () => {},
  onSelect = () => {},
  showActionButtons = true,
  defaultValue = '',
  optionsWrapperClassName = '',
  children = null,
  ...rest
}) => {
  const { t } = useTranslation()
  const [val, setVal] = useState(value)

  useEffect(() => {
    setVal(value)
  }, [value])

  useEffect(() => {
    onSelect(val)
  }, [val])

  const applyValue = useCallback(() => {
    onApply(val)
  }, [onApply, val])

  const dropFilter = useCallback(() => {
    setVal(defaultValue)
    onDrop()
  }, [setVal])

  return (
    <>
      {label?.length > 0 && <DropdownText>{t(label)}</DropdownText>}
      <div
        className={optionsWrapperClassName}
        onChange={(e) => {
          e.stopPropagation()
          setVal(e.target.value)
        }}
      >
        {options.map((option) => (
          <DropdownItem key={name + '-option' + option.value}>
            <ControlLabel
              checked={val === option.value}
              name={name}
              control={<Radio />}
              label={
                rest?.renderLabel ? rest.renderLabel(option) : t(option.label)
              }
              value={option.value}
            />
          </DropdownItem>
        ))}
      </div>
      {children}
      <ActionButtons
        dropFilter={dropFilter}
        applyValue={applyValue}
        showActionButtons={showActionButtons}
      />
    </>
  )
}

RadioGroup.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  options: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.any }),
  ),
  onApply: PropTypes.func,
  onSelect: PropTypes.func,
  showActionButtons: PropTypes.bool,
  defaultValue: PropTypes.any,
  optionsWrapperClassName: PropTypes.string,
  onDrop: PropTypes.func,
  children: PropTypes.element,
}

export default RadioGroup
